import React from 'react';
import { Helmet } from 'react-helmet';
import '../styles/hobbies.css';

function Hobbies() {
  return (
    <div className="main">
      <div id="hobbies">
        <Helmet>
          <title>Hobbies - Hannes Lundin</title>
          <link rel="canonical" href="https://hanneslundin.com/hobbies" />
        </Helmet>
        <section>
          <h2>Hobbies</h2>
          <p>
            When I'm not working on web development, I enjoy a variety of hobbies that help me stay creative and balanced.
          </p>

          <h3>Esports and Streaming</h3>
          <p>
            I love esports and have spent a lot of time playing competitively, especially in League of Legends where I've reached Master Tier. This shows my competitive spirit, strategic thinking, and dedication.
          </p>
          <p>
            I also enjoy sharing my gaming experiences with others. You can find my live streams on <a href="https://www.twitch.tv/lundet" target="_blank" rel="noopener noreferrer">Twitch</a> and my recorded content on <a href="https://www.youtube.com/channel/UCRe_1SKE84GFzgbpG_eEPPA" target="_blank" rel="noopener noreferrer">YouTube</a>.
          </p>

          <h3>Music Production</h3>
          <p>
            I enjoy making music with FL Studio and playing guitar in my free time. It's a great way to unwind and express myself. Music allows me to take a break from coding and have some creative fun.
          </p>
        </section>
      </div>
    </div>
  );
}

export default Hobbies;
